// extracted by mini-css-extract-plugin
export default {"pdfContainer":"styles_pdfContainer__iGaiu"};